import { element, string } from 'prop-types';
import React, { Component } from 'react';
import Error from 'components/Error';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    console.log(info); // eslint-disable-line
  }

  render() {
    return this.state.hasError ? (
      <Error message={this.props.errorMessage} />
    ) : (
      this.props.children
    );
  }
}

ErrorBoundary.defaultProps = {
  errorMessage: undefined
};

ErrorBoundary.propTypes = {
  errorMessage: string,
  children: element.isRequired
};

export default ErrorBoundary;
